import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { map, of, tap, catchError, mergeMap } from 'rxjs'
import {
  login_failed,
  login_success,
  logout_failed,
  logout_success,
  start_logout,
  start_sso_login, start_support_user_login
} from '../action/auth.action'
import { AppState } from '../state/app.state'
import { AuthService } from 'src/services/auth/auth.service'
import { CommonService } from 'src/services/common/common.service'
import { GlobalConstants } from 'src/constants/global-constants'

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private cs: CommonService,
    private appState: Store<AppState>
  ) {}

  loginRedirect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(login_success),
        tap(action => {
          this.cs.routeTo(GlobalConstants.ROUTING.DASHBOARD)
        })
      )
    },
    { dispatch: false }
  )

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(start_logout),
      mergeMap(action =>
        this.authService.logout().pipe(
          map((response: any) => {
            return logout_success({ data: response })
          }),
          catchError((error: any) => {
            let errorMsg = JSON.parse(error.toString().replace('Error: ', '')).error.message
            this.cs.showError(errorMsg, 'LOGOUT FAILED', true)
            return of(logout_failed(error))
          })
        )
      )
    )
  )

  logoutRedirect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(logout_success),
        tap(action => {
          this.authService.clearLocalStorageAndRedirectToLogin()
        })
      )
    },
    { dispatch: false }
  )

  sso_login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(start_sso_login),
      mergeMap(({ access_token }) =>
        this.authService.ssoLogin(access_token).pipe(
          map((response: any) => {
            AuthService.setToken(response.token)
            AuthService.setRefreshToken(response.refreshToken)
            return login_success({ bearer_token: response.token })
          }),
          catchError((error: any) => {
            const errorMsg = JSON.parse(error?.message)?.error?.message || 'Unable to proceed at this time'
            this.cs.showError(errorMsg, 'Error', true)
            return of(login_failed(error))
          })
        )
      )
    )
  )

  start_support_user_login$ = createEffect(() => this.actions$.pipe(
    ofType(start_support_user_login),
    mergeMap(({token}) =>
      this.authService.supportUserLogin(token).pipe(
        map((response: any) => {
          AuthService.setToken(response.token)
          AuthService.setRefreshToken(response.refreshToken)
          return login_success({ bearer_token: response.token })
        }),
        catchError((error: any) => {
          const errorMsg = JSON.parse(error?.message)?.error?.message || 'Unable to proceed at this time'
          this.cs.showError(errorMsg, 'Error', true)
          return of(login_failed(error))
        })
      )
    )
  ))
}
